import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-ui-shimmer-fragment',
  standalone: true,
  templateUrl: './shimmer-fragment.component.html',
  styleUrls: ['./shimmer-fragment.component.scss'],
})
export class ShimmerFragmentLibComponent {
  type = input<'rectangle' | 'circle'>();
  width = input<'55' | '65' | '75' | '85' | '90' | '95' | '100'>('100');
  height = input<string>('20');
  marginBottom = input<'5' | '10' | '15' | '20'>('5');
  marginTop = input<'0' | '5' | '10' | '15' | '20'>('0');
}
